const en_whs_itemin = {
    "": "item in",
}

export default en_whs_itemin;